import Breadcrumb from "../../../../components/breadcrumbs/Breadcrumb.vue";
import { EmpenhoService } from "../../../../services/EmpenhoService";
import { SnackBarModule } from "../../../../modules/SnackBarModule";

export default {
  name: "VisualizarEmpenho",
  components: {
    Breadcrumb
  },
  data: () => ({
    breadcrumbs: [
      {
        text: 'Página Inicial',
        disabled: false,
        href: '/',
      },
      {
        text: 'Processos de Compras',
        disabled: false,
        href: '/gerenciar-processos-compras',
      },
      {
        text: 'Gerenciar Especificações de Empenhos (SIAD)',
        disabled: false,
        href: '/gerenciar-empenhos',
      },
      {
        text: 'Visualizar Empenho',
        disabled: true
      }
    ],
    empenho: {},
    empenhoId: null,
    loading: false,
  }),
  created() {
    this.empenhoId = this.$route.params.id;
    if (this.empenhoId) {
      this.carregarEmpenho();
    } else {
      SnackBarModule('ID do empenho não fornecido!', 'error');
      this.$router.push('/gerenciar-empenhos');
    }
  },
  methods: {
    async carregarEmpenho() {
      try {
        this.loading = true;
        const response = await EmpenhoService.show(this.empenhoId);
        if (!response.error && response.data) {
          this.empenho = {
            ...response.data,
            ano_empenho: response.data.ano_empenho ?? '-',
            numero_empenho: response.data.numero_empenho ?? '-',
            numero_processo_formatado: response.data.numero_processo_formatado ?? '-',
            numero_contrato: response.data.numero_contrato ?? '-',
            cnpj_cpf_fornecedor: response.data.cnpj_cpf_fornecedor ?? '-',
            nome_fornecedor: response.data.nome_fornecedor ?? '-',
            codigo_elemento_item_despesa: response.data.codigo_elemento_item_despesa ?? '-',
            elemento_despesa_codigo: response.data.elemento_despesa_codigo ?? '-',
            elemento_item_codigo: response.data.elemento_item_codigo ?? '-',
            codigo_item_material_servico: response.data.codigo_item_material_servico ?? '-',
            item_material_servico: response.data.item_material_servico ?? '-',
            descricao_material_servico: response.data.descricao_material_servico ?? '-',
            natureza_despesa: response.data.natureza_despesa ?? '-',
            codigo_unidade_contabil_executora: response.data.codigo_unidade_contabil_executora ?? '-',
            codigo_unidade_orcamentaria: response.data.codigo_unidade_orcamentaria ?? '-',
            codigo_identificador_orcamento: response.data.codigo_identificador_orcamento ?? '-',
            fonte_recurso_codigo: response.data.fonte_recurso_codigo ?? '-',
            funcao_codigo: response.data.funcao_codigo ?? '-',
            codigo_subfuncao: response.data.codigo_subfuncao ?? '-',
            codigo_programa: response.data.codigo_programa ?? '-',
            codigo_acao: response.data.codigo_acao ?? '-',
            codigo_subprojeto_subatividade: response.data.codigo_subprojeto_subatividade ?? '-',
            grupo_codigo: response.data.grupo_codigo ?? '-',
            codigo_procedencia: response.data.codigo_procedencia ?? '-',
            tipo_especificacao: response.data.tipo_especificacao ?? '-',
            numero_especificacao: response.data.numero_especificacao ?? '-',
            data_efetivacao_especificacao: response.data.data_efetivacao_especificacao ?? '-',
            empenho_valor_total: response.data.empenho_valor_total ?? 0,
            ajuste_financeiro_rp_valor_total: response.data.ajuste_financeiro_rp_valor_total ?? 0,
            ajuste_financeiro_valor_total: response.data.ajuste_financeiro_valor_total ?? 0,
            conformidade_orcamentaria_qtde: response.data.conformidade_orcamentaria_qtde ?? 0,
            conformidade_orcamentaria_valor_total: response.data.conformidade_orcamentaria_valor_total ?? 0,
            conformidade_rp_qtde: response.data.conformidade_rp_qtde ?? 0,
            conformidade_rp_valor_total: response.data.conformidade_rp_valor_total ?? 0,
            reforco_empenho_qtde: response.data.reforco_empenho_qtde ?? 0,
            reforco_empenho_valor_total: response.data.reforco_empenho_valor_total ?? 0,
            anulacao_empenho_qtde: response.data.anulacao_empenho_qtde ?? 0,
            anulacao_empenho_valor_total: response.data.anulacao_empenho_valor_total ?? 0,
            anulacao_conformidade_orcamentaria_qtde: response.data.anulacao_conformidade_orcamentaria_qtde ?? 0,
            anulacao_conformidade_orcamentaria_valor_total: response.data.anulacao_conformidade_orcamentaria_valor_total ?? 0,
            anulacao_conformidade_rp_qtde: response.data.anulacao_conformidade_rp_qtde ?? 0,
            anulacao_conformidade_rp_valor_total: response.data.anulacao_conformidade_rp_valor_total ?? 0,
            cancelamento_rp_qtde: response.data.cancelamento_rp_qtde ?? 0,
            cancelamento_rp_valor_total: response.data.cancelamento_rp_valor_total ?? 0,
          };
        } else {
          SnackBarModule('Não foi possível carregar os dados do empenho.', 'error');
          this.$router.push('/gerenciar-empenhos');
        }
      } catch (error) {
        console.error('Erro ao carregar empenho:', error);
        SnackBarModule('Ocorreu um erro ao carregar os dados do empenho.', 'error');
        this.$router.push('/gerenciar-empenhos');
      } finally {
        this.loading = false;
      }
    },
    getNumeroEmpenhoCompleto() {
      if (this.empenho.numero_empenho && this.empenho.codigo_unidade_contabil_executora && this.empenho.ano_empenho) {
        return `${this.empenho.codigo_unidade_contabil_executora}-${this.empenho.numero_empenho}/${this.empenho.ano_empenho}`;
      }
      if (this.empenho.numero_empenho && this.empenho.codigo_unidade_contabil_executora) {
        return `${this.empenho.codigo_unidade_contabil_executora}-${this.empenho.numero_empenho}`;
      }
      return this.empenho.numero_empenho || '-';
    },
    formatCnpjCpf(value) {
      if (!value || value === '-') return '-';
      const cleaned = value.replace(/\D/g, '');
      if (cleaned.length === 11) {
        return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else if (cleaned.length === 14) {
        return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
      return value;
    },
    formatCurrency(value) {
      if (!value && value !== 0) return 'R$ 0,00';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value);
    },
    formatDate(date) {
      if (!date || date === '-') return '-';
      try {
        const dateObj = new Date(date);
        if (isNaN(dateObj.getTime())) return date;
        return dateObj.toLocaleDateString('pt-BR');
      } catch (error) {
        return date;
      }
    },
    voltarParaGerenciar() {
      this.$router.push('/gerenciar-empenhos');
    }
  }
};

